import { applySnapshot, types, getSnapshot } from "mobx-state-tree";
import Uuid from "uuid";
import * as moment from "moment-timezone";

moment.tz.setDefault("Asia/Tokyo");

const templatedStories = ["d", "e", "f", "u"];
const zeroChildImpossibleStories = ["c", "g", "h", "n"];

// Bridal追加
const Bridal = types
  .model("Bridal", {
    key: types.optional(types.string, ""),
    venueCode: types.optional(types.string, ""),
    customerName: types.optional(types.string, ""),
    weddingDate: types.optional(types.string, ""),
    style: types.optional(types.string, ""),
    brideColor: types.optional(types.string, ""),
    groomColor: types.optional(types.string, ""),
    isVideo: types.optional(types.boolean, false)
  })
  .actions(self => ({
    changeKey: v => (self.key = v),
    changeVenueCode: v => (self.venueCode = v),
    changecustomerName: v => (self.customerName = v),
    changeWeddingDate: v => (self.weddingDate = v),
    changeStyle: v => (self.style = v),
    changeBrideColor: v => (self.brideColor = v),
    changeGroomColor: v => (self.groomColor = v),
    changeIsVideo: v => (self.isVideo = v),
    updateFromApi: data => {
      // APIから取得したデータで一括更新
      if (data.key !== undefined) self.key = data.key;
      if (data.venueCode !== undefined) self.venueCode = data.venueCode;
      if (data.customerName !== undefined) self.customerName = data.customerName;
      if (data.weddingDate !== undefined) self.weddingDate = data.weddingDate;
      if (data.style !== undefined) self.style = data.style;
      if (data.brideColor !== undefined) self.brideColor = data.brideColor;
      if (data.groomColor !== undefined) self.groomColor = data.groomColor;
      if (data.isVideo !== undefined) self.isVideo = data.isVideo;
    }
  }));

const Face = types
  .model("Face", {
    layer1: "",
    layer2: "",
    layer3: "",
    layer4: "",
    layer5: ""
  })
  .actions(self => ({
    changeLayer1: v => (self.layer1 = v),
    changeLayer2: v => (self.layer2 = v),
    changeLayer3: v => (self.layer3 = v),
    changeLayer4: v => (self.layer4 = v),
    changeLayer5: v => (self.layer5 = v),

    changeAll: v => applySnapshot(self, v)
  }))
  .views(self => ({
    get isSet() {
      return (
        self.layer1 !== "" &&
        self.layer2 !== "" &&
        self.layer3 !== "" &&
        self.layer4 !== "" &&
        self.layer5 !== ""
      );
    }
  }));

const Child = types
  .model("Child", {
    type: 0,
    gender: 0
  })
  .actions(self => ({
    changeType: v => {
      self.type = v;
      self.gender = self.type === 0 ? -1 : self.gender === -1 ? 0 : self.gender;
    },
    changeGender: v => (self.gender = v),
    setUpFromId: v => {
      switch (v) {
        case 0:
          self.changeType(0);
          break;
        case 1:
          self.changeType(1);
          self.changeGender(0);
          break;
        case 2:
          self.changeType(1);
          self.changeGender(1);
          break;
      }
    }
  }))
  .views(self => ({
    get id() {
      const id = self.type === 0 ? 0 : self.gender === 0 ? 1 : 2;
      return id;
    }
  }));

const Children = types
  .model("Children", {
    child1: types.optional(Child, Child.create({ genre: 0, type: 0 })),
    child2: types.optional(Child, Child.create({ genre: 0, type: 0 })),
    child3: types.optional(Child, Child.create({ genre: 0, type: 0 }))
  })
  .views(self => ({
    id(nb) {
      return [self.child1.id, self.child2.id, self.child3.id]
        .slice(0, nb)
        .sort((a, b) => b - a)
        .join("");
    }
  }));

const Pet = types
  .model("Pet", {
    type: 0,
    color: 0
  })
  .actions(self => ({
    changeType: v => {
      self.type = v; // 犬 0 | 猫 3
      self.color = self.color;
    },
    changeColor: v => (self.color = v),
    setUpFromId: v => {
      switch (v) {
        case 0:
          self.changeType(0);
          self.changeColor(0);
          break;
        case 1:
          self.changeType(0);
          self.changeColor(1);
          break;
        case 2:
          self.changeType(0);
          self.changeColor(2);
          break;
        case 3:
          self.changeType(3);
          self.changeColor(0);
          break;
        case 4:
          self.changeType(3);
          self.changeColor(1);
          break;
        case 5:
          self.changeType(3);
          self.changeColor(2);
          break;
      }
    }
  }))
  .views(self => ({
    get id() {
      const id = self.type + self.color;
      return id;
    }
  }));

const Pets = types
  .model("Pets", {
    pet1: types.optional(Pet, Pet.create({ genre: 0, type: 0 })),
    pet2: types.optional(Pet, Pet.create({ genre: 0, type: 0 })),
  })
  .views(self => ({
    id(nb) {
      return [self.pet1.id, self.pet2.id]
        .slice(0, nb)
        .sort((a, b) => b - a)
        .join("");
    }
  }));

const Sibling = types
  .model("Sibling", {
    gender: 0
  })
  .actions(self => ({
    changeGender: v => (self.gender = v),
    setUpFromId: v => {
      // console.log({v});
      switch (v) {
        case 0:
          self.changeGender(0);
          break;
        case 1:
          self.changeGender(1);
          break;
      }
    }
  }))
  .views(self => ({
    get id() {
      const id = self.gender;
      return id;
    }
  }));

export const Siblings = types
  .model("Siblings", {
    sibling1: types.optional(Sibling, Sibling.create({ gender: 0 })),
    sibling2: types.optional(Sibling, Sibling.create({ gender: 0 })),
  })
  .views(self => ({
    id(nb) {
      return [self.sibling1.id, self.sibling2.id]
        .slice(0, nb)
        .sort((a, b) => b - a)
        .join("");
    }
  }));

const SavableFace = types.compose(
  types
    .model({
      saved: Face
    })
    .actions(self => ({
      save: () => self.saved.changeAll(getSnapshot(self))
    }))
    .views(self => ({
      get isSaved() {
        return (
          self.saved !== null &&
          self.layer1 === self.saved.layer1 &&
          self.layer2 === self.saved.layer2 &&
          self.layer3 === self.saved.layer3 &&
          self.layer4 === self.saved.layer4 &&
          self.layer5 === self.saved.layer5
        );
      }
    })),
  Face
);

// 親から子へのシカケテガミ用
const ParentToChild = types
  .model("ParentToChild", {
    creatorName: "", // 作成者
    receiverName: "", // プレゼント対象の子供
    childrenAge: "", // 子供の年齢
    childrenSex: "", // 子供の性別
    creatorNickName: "", // 子供から呼ばれる呼び名
    isSingle: "1", // 配偶者の有無 "0" | "1"
    spouseNickName: "", // 子供から呼ばれる配偶者の呼び名
    grandParentState: "4", // 祖父母について
    grandFatherNickName: "", // 子供から呼ばれる祖父の呼び名
    grandMotherNickName: "", // 子供から呼ばれる祖母の呼び名
    customDate: types.optional(types.Date, moment().toDate()), // プレゼント日
    boyFace: types.optional( // 男の子の顔画像パーツ名
      Face,
      Face.create({
        layer1: "",
        layer2: "",
        layer3: "",
        layer4: "",
        layer5: ""
      })
    ),
    girlFace: types.optional( // 女の子の顔画像パーツ名
      Face,
      Face.create({
        layer1: "",
        layer2: "",
        layer3: "",
        layer4: "",
        layer5: ""
      })
    ),
    papaFace: types.optional( // パパの顔画像パーツ名
      Face,
      Face.create({
        layer1: "",
        layer2: "",
        layer3: "",
        layer4: "",
        layer5: ""
      })
    ),
    mamaFace: types.optional( // ママの顔画像パーツ名
      Face,
      Face.create({
        layer1: "",
        layer2: "",
        layer3: "",
        layer4: "",
        layer5: ""
      })
    ),
    stories: types.optional(types.array(types.string), ["", "", "", "", ""]), // ストーリー
    personalMessage: types.optional( // メッセージ
      types.array(types.string),
      [
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        ""
      ]
    ),
    personalFont: types.optional( // メッセージフォント
      types.enumeration("Font", [
        "beautiful",
        "banana",
        "hui",
        "malecharacter",
        "shigoto",
        "genshin",
        "darts",
        "kacho",
        "anzu",
        "uzura"
      ]),
      "malecharacter"
    ),
    bandId: -1, // 帯のテキストデザイン
    id: Uuid.v4(),
  })
  .actions(self => ({
    changeCreatorName: v => (self.creatorName = v),
    changeReceiverName: v => (self.receiverName = v),
    changeReceiver: v => (self.receiver = v),
    changeChildrenAge: v => (self.childrenAge = v),
    changeChildrenSex: v => (self.childrenSex = v),
    changeCreatorNickName: v => (self.creatorNickName = v),
    changeIsSingle: v => (self.isSingle = v),
    changeSpouseNickName: v => (self.spouseNickName = v),
    changeGrandParentState: v => (self.grandParentState = v),
    changeGrandFatherNickName: v => (self.grandFatherNickName = v),
    changeGrandMotherNickName: v => (self.grandMotherNickName = v),
    changeCustomDate: v => (self.customDate = v),
    changePersonalFont: n => (self.personalFont = n),
    setPersonalMessage: (k, v) => (self.personalMessage[k] = v),
    changeBandId: v => (self.bandId = v),
    setStory: (k, v) => (self.stories[k] = v),
    // exclusionListのものをstoriesから除いて空文字にする
    exclusionStories: (exclusionList) => {
      for (let i = 0; i < self.stories.length; i++) {
        if (exclusionList.some((exclusionid) => self.stories[i] === exclusionid)) {
          self.setStory(i, '');
        }
      }
    }
  }))
  .views(self => ({
    get isInfoSet() {
      let b = false;
      // 必須項目を満たしているか
      if (
        self.creatorName !== "" &&
        self.receiverName !== "" &&
        // self.childrenAge !== "" &&
        self.childrenSex !== "" &&
        self.creatorNickName !== "" &&
        self.grandParentState != null &&
        self.grandParentState !== "4" &&
        self.customDate !== undefined
      ) {
        // 配偶者なしか
        if (self.isSingle === "1") {
          // 祖父母の状態
          if (self.grandParentState === "0") {
            if (
              self.grandFatherNickName !== "" &&
              self.grandMotherNickName !== ""
            ) {
              b = true;
            }
          } else if (self.grandParentState === "1") {
            if (self.grandFatherNickName !== "") {
              b = true;
            }
          } else if (self.grandParentState === "2") {
            if (self.grandMotherNickName !== "") {
              b = true;
            }
          } else {
            b = true;
          }
        } else {
          if (self.spouseNickName !== "") {
            // 祖父母の状態
            if (self.grandParentState === "0") {
              if (
                self.grandFatherNickName !== "" &&
                self.grandMotherNickName !== ""
              ) {
                b = true;
              }
            } else if (self.grandParentState === "1") {
              if (self.grandFatherNickName !== "") {
                b = true;
              }
            } else if (self.grandParentState === "2") {
              if (self.grandMotherNickName !== "") {
                b = true;
              }
            } else {
              b = true;
            }
          }
        }
      }

      return b;
    },
    get areStoriesSet() {
      return self.stories.indexOf('') === -1;
    }
  }));

// 子から親へのシカケテガミ用
const ChildToParent = types
  .model("ChildToParent", {
    blurbName: "", // 推薦人の名前
    blurbText: 0, // 推薦文の番号
    childType: "", // 贈る側の種類 'daughter' | 'son' ユーザー操作ではなく、訪問時にフロントで設定
    creatorName: "", // 作成者
    receiver: "", // プレゼント対象 '' | 'dad' | 'mom' 両親・父・母
    dadName: "", // お父様の名前
    hasLifeChangingWordsFromDad: "0", // 人生を変えた父からの言葉があるか '0' | '1'
    lifeChangingWordsFromDad: "", // 人生を変えた父からの言葉
    momName: "", // お母様の名前
    hasLifeChangingWordsFromMom: "0", // 人生を変えた母からの言葉があるか '0' | '1'
    lifeChangingWordsFromMom: "", // 人生を変えた母からの言葉
    customDate: types.optional(types.Date, moment().toDate()), // プレゼント日
    sibling: 0, // 兄弟・姉妹の数 0 | 1 | 2
    siblingTemplate: 0, // 兄弟・姉妹の数・性別パターン
    childName: "", // 子どもの名前(1人の時のみ使用)
    children: 0, // 子どもの数 0 | 1 | 2 | 3
    pets: 0, // ペットの数
    petsTemplate: 0, // ペットのパターン
    dadFace: types.optional( // お父様の顔画像パーツ名
      Face,
      Face.create({
        layer1: "",
        layer2: "",
        layer3: "",
        layer4: "",
        layer5: ""
      })
    ),
    momFace: types.optional( // お母様の顔画像パーツ名
      Face,
      Face.create({
        layer1: "",
        layer2: "",
        layer3: "",
        layer4: "",
        layer5: ""
      })
    ),
    creatorFace: types.optional( // 作成者の顔画像パーツ名
      Face,
      Face.create({
        layer1: "",
        layer2: "",
        layer3: "",
        layer4: "",
        layer5: ""
      })
    ),
    storyOrder: "0", // 両親宛て用でフロントのみ使用 '0' | '1' 父->母 母->父 でストーリーのブロックの並び替え
    stories: types.optional(types.array(types.string), ["", "", "", "", "", ""]), // ストーリー 両親へは6 片親へは4
    personalMessage: types.optional(types.array(types.string), ["", "", "", "", "", "", "", ""]), // 自由メッセージ
    personalFont: types.optional( // 自由メッセージフォント
      types.enumeration("Font", [ // 娘から〜はママから子へと同じ
        "anzu",
        "uzura",
        "hui",
        "darts",
        "beautiful",
        "genshin",
        "malecharacter",
        "banana",
        "kacho",
      ]),
      "anzu"
    ),
    id: Uuid.v4(),
  })
  .actions(self => ({
    changeBlurbName: n => (self.blurbName = n),
    changeBlurbText: n => (self.blurbText = n),
    changeChildType: v => (self.childType = v),
    changeCreatorName: v => (self.creatorName = v),
    changeReceiver: v => (self.receiver = v),
    changeDadName: v => (self.dadName = v),
    changeHasLifeChangingWordsFromDad: v => (self.hasLifeChangingWordsFromDad = v),
    changeLifeChangingWordsFromDad: v => (self.lifeChangingWordsFromDad = v),
    changeMomName: v => (self.momName = v),
    changeHasLifeChangingWordsFromMom: v => (self.hasLifeChangingWordsFromMom = v),
    changeLifeChangingWordsFromMom: v => (self.lifeChangingWordsFromMom = v),
    changeCustomDate: v => (self.customDate = v),
    changeSibling: v => {
      self.sibling = parseInt(v) || 0;
    },
    changeSiblingTemplate: v => {
      self.siblingTemplate = parseInt(v) || 0;
    },
    changeChildName: v => (self.childName = v),
    changeChildren: v => {
      self.children = parseInt(v) || 0;
    },
    changePets: n => {
      self.pets = parseInt(n) || 0;
      self.petsTemplate =
        self.pets === 0
          ? 0
          : self.petsTemplate ||
          (self.pets === 1 ? 1 : self.pets === 2 ? 4 : 10);
    },
    changePetsTemplate: n => {
      self.petsTemplate = parseInt(n) || 0;
    },
    changeStoryOrder: v => {
      self.storyOrder = v
    },
    changePersonalFont: n => (self.personalFont = n),
    setPersonalMessage: (k, v) => (self.personalMessage[k] = v),
    setStory: (k, v) => (self.stories[k] = v),
    removeStoriesLastTwo: () => { // 片親に贈る時はストーリーの2つを削除
      console.log('removeStoriesLastTwo');
      self.stories.splice(-2, 2);
    },
    resetStories: () => {
      for (let i = 0; i < self.stories.length; i++) {
        self.setStory(i, '');
      }
    },
    // exclusionListのものをstoriesから除いて空文字にする
    exclusionStories: (exclusionList) => {
      for (let i = 0; i < self.stories.length; i++) {
        if (exclusionList.some((exclusionid) => self.stories[i] === exclusionid)) {
          self.setStory(i, '');
        }
      }
    }
  }))
  .views(self => ({
    get isInfoSet() { // InformationsChildToParent.js から次のStepに進めるか
      if (self.creatorName === "") return false;
      if (self.customDate === undefined) return false;
      // 子ども一人の時はストーリーに使用するので子供の名前が必要
      if (self.children === 1 && self.childName === "") return false;
      // 人生を変えた言葉がある時はストーリーに使用するので言葉が必要(父)
      if (self.hasLifeChangingWordsFromDad !== "0" && self.lifeChangingWordsFromDad === "") return false;
      // 人生を変えた言葉がある時はストーリーに使用するので言葉が必要(母)
      if (self.hasLifeChangingWordsFromMom !== "0" && self.lifeChangingWordsFromMom === "") return false;
      // // 贈る相手の名前が必要
      if (self.receiver !== "mom" && self.dadName === "") return false;
      if (self.receiver !== "dad" && self.momName === "") return false;
      // 上記問題なければtrueを返す
      return true;
    },
    get areStoriesSet() {
      return self.stories.indexOf('') === -1;
    }
  }));

// ?newでアクセス時に親から子・子から親へのシカケテガミに関連するcookieの値を初期化する
const clearParentToChildCookieData = (data) => {
  return {};
};

// ?newでアクセス時に男性から女性に贈る・女性から男性へのシカケテガミに関連するcookieの値を初期化する
const clearMaleToFemaleCookieData = (data) => {
  const o = {};
  // TODO: 今後商品が増えると残すデータは増える
  // 親から子・子から親へのシカケテガミに関連するデータは残す
  if (data != null) {
    o.parentToChild = data.parentToChild || {};
    o.childToParent = data.childToParent || {};
    o.bridal = {};
  } else {
    o.parentToChild = {};
    o.childToParent = {};
    o.bridal = {};
  }
  return o;
};

const Book = types
  .model("Book", {
    artistName: "",
    productType: "",
    customDate: types.optional(types.Date, moment().toDate()),
    blurbNickname: "", // TODO: 使用しない？
    blurbName: "",
    blurbText: 0,
    childName: "",
    children: 0,
    childrenTemplate: 0,
    likedHomeCooking: "", // その方がつくる好きな手料理
    creatorFace: types.optional(
      Face,
      Face.create({
        layer1: "",
        layer2: "",
        layer3: "",
        layer4: "",
        layer5: ""
      })
    ),
    creatorName: "",
    id: Uuid.v4(),
    personalMessage: types.optional(types.array(types.string), [
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      ""
    ]),
    personalFont: types.optional(
      types.enumeration("Font", [
        "beautiful",
        "banana",
        "hui",
        "malecharacter",
        "shigoto",
        "genshin",
        // 女性から男性に贈る
        "anzu",
        "uzura",
        "darts"
      ]),
      "beautiful"
    ),
    receiverFace: types.optional(
      Face,
      Face.create({
        layer1: "",
        layer2: "",
        layer3: "",
        layer4: "",
        layer5: ""
      })
    ),
    receiverName: "", // 送りたい相手の遊び名
    stories: types.optional(types.array(types.string), ["", "", "", "", ""]),
    parentToChild: types.optional(
      ParentToChild,
      ParentToChild.create({
        creatorName: "",
        receiverName: "",
        childrenAge: "",
        childrenSex: "",
        creatorNickName: "",
        isSingle: "1",
        spouseNickName: "",
        grandParentState: "4",
        grandFatherNickName: "",
        grandMotherNickName: "",
      })
    ),
    childToParent: types.optional(
      ChildToParent,
      ChildToParent.create({
        childType: "",
        creatorName: "",
        receiver: "",
        dadName: "",
        hasLifeChangingWordsFromDad: "0",
        lifeChangingWordsFromDad: "",
        momName: "",
        hasLifeChangingWordsFromMom: "0",
        lifeChangingWordsFromMom: "",
        sibling: 0,
        siblingTemplate: 0,
        storyOrder: "0",
      })
    ),
    // bridal
    bridal: types.optional(
      Bridal,
      Bridal.create({
        key: "",
        venueCode: "",
        customerName: "",
        weddingDate: "",
        style: "",
        brideColor: "",
        groomColor: "",
        isVideo: false
      })
    ),
    // 女性から男性へのシカケテガミ ペット(子供 children を流用)
    pets: 0,
    petsTemplate: 0,
    isOrderedDigital: false // デジタル商品の追加有無
  })
  .actions(self => ({
    changeArtistName: n => (self.artistName = n),
    changeProductType: n => (self.productType = n),
    changeBlurbName: n => (self.blurbName = n),
    changeBlurbText: n => (self.blurbText = n),
    changeChildName: n => (self.childName = n),
    changeChildren: n => {
      self.children = parseInt(n) || 0;
      self.childrenTemplate =
        self.children === 0
          ? 0
          : self.childrenTemplate ||
          (self.children === 1 ? 1 : self.children === 2 ? 4 : 10);
      if (self.children === 0) {
        self.stories.forEach((v, k) => {
          const s = v.substring(0, 1);
          if (zeroChildImpossibleStories.indexOf(s) !== -1) {
            self.setStory(k, '');
          }
        });
      }
    },
    changeChildrenTemplate: n => {
      self.childrenTemplate = parseInt(n) || 0;
      self.stories.forEach((v, k) => {
        self.setStory(k, v.substring(0, 1));
      });
    },
    // 女性から男性に贈る
    changeFemaleToMaleChildren: n => {
      // console.log('changeFemaleToMaleChildren', n);
      self.children = parseInt(n) || 0;
      self.childrenTemplate =
        self.children === 0
          ? 0
          : self.childrenTemplate ||
          (self.children === 1 ? 1 : self.children === 2 ? 4 : 10);
    },
    changeFemaleToMaleChildrenTemplate: n => {
      // console.log('changeFemaleToMaleChildrenTemplate', n);
      self.childrenTemplate = parseInt(n) || 0;
      if (n === 0) { // 保存時に子供が0の時
        self.stories.forEach((v, k) => {
          if (v === "s") {
            self.setStory(k, '');
          }
        });
      }
    },
    changePets: n => {
      self.pets = parseInt(n) || 0;
      self.petsTemplate =
        self.pets === 0
          ? 0
          : self.petsTemplate ||
          (self.pets === 1 ? 1 : self.pets === 2 ? 4 : 10);
    },
    changePetsTemplate: n => {
      self.petsTemplate = parseInt(n) || 0;
    },
    setFemaleToMaleStory: (k, v) => (self.stories[k] = v),

    changeCreatorName: n => (self.creatorName = n),
    changeLikedHomeCooking: n => (self.likedHomeCooking = n),
    changePersonalFont: n => (self.personalFont = n),
    changeReceiverName: n => (self.receiverName = n),
    changeReceiver: n => (self.receiver = n),
    changeCustomDate: n => (self.customDate = n),

    setPersonalMessage: (k, v) => (self.personalMessage[k] = v),
    // 男性から女性のみ、ストーリーのアルファベットの後に childrenTemplate を付与して送っている
    setStory: (k, v) =>
    (self.stories[k] =
      templatedStories.indexOf(v) !== -1 && self.childrenTemplate !== 0
        ? `${v}${self.childrenTemplate}`
        : v),
    changeIsOrderedDigital: n => (self.isOrderedDigital = n),
  }))
  .views(self => ({
    get childrenRender() {
      return self.children === 1
        ? `${self.childName}`
        : self.children !== 0
          ? `子供たち`
          : "";
    },
    get childrenToRender() {
      return self.children === 1
        ? `と${self.childName}`
        : self.children !== 0
          ? `と子供たち`
          : "";
    },
    // 男性から女性へのシカケテガミ用 step1の入力が入ってるか
    get isInfoSet() {
      return (
        self.creatorName !== "" &&
        self.receiverName !== "" &&
        self.likedHomeCooking !== "" &&
        self.customDate !== undefined &&
        (self.children !== 1 || self.childName !== "")
      );
    },
    // 女性から男性へのシカケテガミ用 step1の入力が入ってるか
    get isInfoSetFemaleToMale() {
      return (
        self.creatorName !== "" &&
        self.receiverName !== "" &&
        self.customDate !== undefined
      );
    },
    get areStoriesSet() {
      return self.stories.indexOf('') === -1;
    }
  }));

export default Book;
export { Book, Child, Children, Face, SavableFace, clearParentToChildCookieData, Pet, Pets, clearMaleToFemaleCookieData, Bridal };


// WEBPACK FOOTER //
// ./src/models/Book.js